import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DraggableSection from './DraggableSection';

/**
 * Renders all sections for one region (header / main / footer) with a
 * header row showing the region name and the "Add section" button.
 *
 * Drag/drop reorder is delegated to <DraggableSection />; this file
 * owns the array math (splice from→to) since it knows the full ordered
 * list.
 */
export default function PageRegionList({
  region, sections, drag, setDrag,
  catalog, brandId, page,
  onAddSection, onPatchSection, onRemoveSection, onComponentChange, onReorderRegion,
}) {
  const reorder = (draggedId, targetId) => {
    const ids = sections.map((s) => s._id);
    const from = ids.indexOf(draggedId);
    const to   = ids.indexOf(targetId);
    if (from < 0 || to < 0) return;
    const next = ids.slice();
    next.splice(from, 1);
    next.splice(to, 0, draggedId);
    onReorderRegion(region, next);
  };

  return (
    <Box mb='24px'>
      <Stack direction='row' justifyContent='space-between' alignItems='center' mb='10px'>
        <Typography variant='body2' fontWeight='700' textTransform='uppercase' color='text.secondary'>
          {region}
        </Typography>
        <Button
          size='small'
          startIcon={<AddIcon />}
          variant='outlined'
          onClick={() => onAddSection(region)}
        >
          Add {region} section
        </Button>
      </Stack>

      {sections.length === 0 && (
        <Typography variant='body2' color='text.secondary' fontStyle='italic' mb='10px'>
          No {region} sections yet.
        </Typography>
      )}

      {sections.map((section) => (
        <DraggableSection
          key={section._id}
          section={section}
          region={region}
          drag={drag}
          setDrag={setDrag}
          onReorder={reorder}
          catalog={catalog}
          brandId={brandId}
          page={page}
          onPatch={(patch) => onPatchSection(section._id, patch)}
          onDelete={() => onRemoveSection(section._id)}
          onComponentChange={onComponentChange}
        />
      ))}
    </Box>
  );
}
